[
  {
    "id": "b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e",
    "gtin": "01000001",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "VBK4",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f",
    "gtin": "01000001",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "H9YO",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d6e7f8a9-b0c1-4d2e-3f4a-5b6c7d8e9f0a",
    "gtin": "01000001",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "U0ES",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "e7f8a9b0-c1d2-4e3f-4a5b-6c7d8e9f0a1b",
    "gtin": "01000002",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "VBK4",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "f8a9b0c1-d2e3-4f4a-5b6c-7d8e9f0a1b2c",
    "gtin": "01000002",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "DEZN",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "a9b0c1d2-e3f4-4a5b-6c7d-8e9f0a1b2c3d",
    "gtin": "01000006",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "ZQ0I",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "b0c1d2e3-f4a5-4b6c-7d8e-9f0a1b2c3d4e",
    "gtin": "01000007",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "5XUT",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "c1d2e3f4-a5b6-4c7d-8e9f-0a1b2c3d4e5f",
    "gtin": "01000008",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "KP5H",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "d2e3f4a5-b6c7-4d8e-9f0a-1b2c3d4e5f6a",
    "gtin": "01000013",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "HVVZ",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "e3f4a5b6-c7d8-4e9f-0a1b-2c3d4e5f6a7b",
    "gtin": "01000016",
    "action": "REORDER",
    "stockLevel": "NO_STOCK",
    "shelfId": "4N8Z",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "f4a5b6c7-d8e9-4f0a-1b2c-3d4e5f6a7b8c",
    "gtin": "01000019",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "OTUP",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "a5b6c7d8-e9f0-4a1b-2c3d-4e5f6a7b8c9d",
    "gtin": "01000021",
    "action": "REORDER",
    "stockLevel": "NO_STOCK",
    "shelfId": "U85I",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "b6c7d8e9-f0a1-4b2c-3d4e-5f6a7b8c9d0e",
    "gtin": "01000022",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "JCBY",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "c7d8e9f0-a1b2-4c3d-4e5f-6a7b8c9d0e1f",
    "gtin": "01000025",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "DA90",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d8e9f0a1-b2c3-4d4e-5f6a-7b8c9d0e1f2a",
    "gtin": "01000026",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "U4OH",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "e9f0a1b2-c3d4-4e5f-6a7b-8c9d0e1f2a3b",
    "gtin": "01000028",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "MKFF",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "f0a1b2c3-d4e5-4f6a-7b8c-9d0e1f2a3b4c",
    "gtin": "01000031",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "90YA",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
    "gtin": "01000032",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "4N8Z",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
    "gtin": "01000034",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "IS38",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f",
    "gtin": "01000037",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "BH23",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "d4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a",
    "gtin": "01000038",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "ZRKO",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b",
    "gtin": "01000040",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "OXVF",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c",
    "gtin": "01000043",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "0ZLK",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d",
    "gtin": "01000045",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "2SU4",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e",
    "gtin": "01000046",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "VG4F",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f",
    "gtin": "01000049",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "3FNR",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a",
    "gtin": "01000051",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "LVPL",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b",
    "gtin": "01000052",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "IS38",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c",
    "gtin": "01000055",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "AA8H",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "a3b4c5d6-e7f8-4a9b-0c1d-2e3f4a5b6c7d",
    "gtin": "9100000161723",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "N2DT",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e",
    "gtin": "01000060",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "OXVF",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f",
    "gtin": "01000065",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "L4QV",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d6e7f8a9-b0c1-4d2e-3f4a-5b6c7d8e9f0a",
    "gtin": "01000102",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "DEZN",
    "isNew": false,
    "status": "COMPLETED"
  }
]